import { Link, useLocation } from 'react-router-dom';

interface Exercise {
  slug: string;
  title: string;
  subtitle: string;
  description: string;
  icon: string;
  time: string;
  level: string;
  praticantes: string;
  dica: string;
}

const allExercises: Exercise[] = [
  {
    slug: 'tecnica-swish-pnl',
    title: 'Técnica Swish',
    subtitle: 'PNL',
    description: 'Substitua padrões mentais indesejados por comportamentos de alta performance.',
    icon: 'ri-refresh-line',
    time: '10 min',
    level: 'Iniciante',
    praticantes: '3.847',
    dica: 'Ideal para criar novos padrões automáticos de comportamento',
  },
  {
    slug: 'ancoragem-emocional',
    title: 'Ancoragem Emocional',
    subtitle: 'PNL',
    description: 'Crie gatilhos instantâneos para acessar estados emocionais positivos.',
    icon: 'ri-anchor-line',
    time: '15 min',
    level: 'Iniciante',
    praticantes: '5.129',
    dica: 'Complementa qualquer técnica com um gatilho de estado mental',
  },
  {
    slug: 'encantations-tony-robbins',
    title: 'Encantations',
    subtitle: 'Tony Robbins',
    description: 'Reprograme seu sistema nervoso com palavras, movimento e emoção.',
    icon: 'ri-fire-line',
    time: '12 min',
    level: 'Iniciante',
    praticantes: '2.943',
    dica: 'Use após qualquer técnica para ancorar o novo estado no corpo',
  },
  {
    slug: 'linha-tempo-pnl',
    title: 'Linha do Tempo',
    subtitle: 'PNL',
    description: 'Reorganize sua história pessoal e liberte-se de emoções do passado.',
    icon: 'ri-time-line',
    time: '20 min',
    level: 'Intermediário',
    praticantes: '4.201',
    dica: 'Ideal para liberar traumas e ressignificar experiências passadas',
  },
  {
    slug: 'ressignificacao-reframing-pnl',
    title: 'Ressignificação',
    subtitle: 'Reframing PNL',
    description: 'Transforme situações limitantes em perspectivas empoderadoras.',
    icon: 'ri-eye-line',
    time: '15 min',
    level: 'Iniciante',
    praticantes: '3.562',
    dica: 'Muda o significado de qualquer situação para um ponto de vista útil',
  },
  {
    slug: 'submodalidades-pnl',
    title: 'Submodalidades',
    subtitle: 'PNL',
    description: 'Descubra os controles internos da mente e ajuste suas experiências.',
    icon: 'ri-settings-3-line',
    time: '20 min',
    level: 'Avançado',
    praticantes: '1.876',
    dica: 'O painel de controle da mente — modifica intensidade de emoções',
  },
  {
    slug: 'modelagem-excelencia-pnl',
    title: 'Modelagem de Excelência',
    subtitle: 'PNL',
    description: 'Replique padrões de sucesso de quem já chegou onde você quer.',
    icon: 'ri-star-line',
    time: '25 min',
    level: 'Intermediário',
    praticantes: '2.134',
    dica: 'Acelera qualquer resultado ao copiar a estrutura interna do sucesso',
  },
  {
    slug: 'identidade-alta-performance',
    title: 'Identidade de Alta Performance',
    subtitle: 'PNL',
    description: 'Torne-se a versão que naturalmente alcança resultados extraordinários.',
    icon: 'ri-user-star-line',
    time: '30 min',
    level: 'Avançado',
    praticantes: '2.891',
    dica: 'Transforma quem você É — não só o que você faz',
  },
  {
    slug: 'proposito-vida',
    title: 'Propósito de Vida',
    subtitle: 'Autoconhecimento',
    description: 'Conecte-se com sua missão única e viva alinhado com seus valores.',
    icon: 'ri-compass-3-line',
    time: '35 min',
    level: 'Iniciante',
    praticantes: '4.567',
    dica: 'Clareza de propósito amplifica o resultado de todas as outras técnicas',
  },
  {
    slug: 'prosperidade-carreira',
    title: 'Prosperidade e Carreira',
    subtitle: 'Manifestação',
    description: 'Manifeste abundância financeira através da reprogramação mental.',
    icon: 'ri-money-dollar-circle-line',
    time: '20 min',
    level: 'Iniciante',
    praticantes: '3.234',
    dica: 'Reprograma crenças inconscientes sobre dinheiro e sucesso',
  },
  {
    slug: 'saude-bem-estar',
    title: 'Saúde e Bem-Estar',
    subtitle: 'Mente-Corpo',
    description: 'Conecte-se com seu corpo ideal e manifeste saúde plena.',
    icon: 'ri-heart-pulse-line',
    time: '18 min',
    level: 'Iniciante',
    praticantes: '2.789',
    dica: 'A conexão mente-corpo amplifica qualquer prática de bem-estar',
  },
  {
    slug: 'amor-ideal',
    title: 'Amor Ideal',
    subtitle: 'Manifestação',
    description: 'Conecte-se com a energia do relacionamento ideal que você merece.',
    icon: 'ri-heart-3-line',
    time: '25 min',
    level: 'Iniciante',
    praticantes: '3.456',
    dica: 'Clareia o que você quer e remove bloqueios em relacionamentos',
  },
];

// Mapa de relações lógicas: próximo passo natural na jornada de PNL
const relatedMap: Record<string, string[]> = {
  'tecnica-swish-pnl': ['ancoragem-emocional', 'ressignificacao-reframing-pnl', 'submodalidades-pnl'],
  'ancoragem-emocional': ['tecnica-swish-pnl', 'submodalidades-pnl', 'encantations-tony-robbins'],
  'encantations-tony-robbins': ['ancoragem-emocional', 'identidade-alta-performance', 'saude-bem-estar'],
  'linha-tempo-pnl': ['ressignificacao-reframing-pnl', 'amor-ideal', 'proposito-vida'],
  'ressignificacao-reframing-pnl': ['linha-tempo-pnl', 'tecnica-swish-pnl', 'submodalidades-pnl'],
  'submodalidades-pnl': ['ancoragem-emocional', 'modelagem-excelencia-pnl', 'tecnica-swish-pnl'],
  'modelagem-excelencia-pnl': ['identidade-alta-performance', 'proposito-vida', 'submodalidades-pnl'],
  'identidade-alta-performance': ['modelagem-excelencia-pnl', 'encantations-tony-robbins', 'proposito-vida'],
  'proposito-vida': ['identidade-alta-performance', 'prosperidade-carreira', 'modelagem-excelencia-pnl'],
  'prosperidade-carreira': ['proposito-vida', 'amor-ideal', 'identidade-alta-performance'],
  'saude-bem-estar': ['ancoragem-emocional', 'encantations-tony-robbins', 'submodalidades-pnl'],
  'amor-ideal': ['linha-tempo-pnl', 'prosperidade-carreira', 'ressignificacao-reframing-pnl'],
};

const levelColors: Record<string, string> = {
  Iniciante: 'text-emerald-600 bg-emerald-50 border-emerald-200',
  Intermediário: 'text-amber-700 bg-amber-50 border-amber-200',
  Avançado: 'text-rose-700 bg-rose-50 border-rose-200',
};

export default function ExerciciosRelacionados() {
  const location = useLocation();
  const currentSlug = location.pathname.replace('/exercicio-gratis/', '');

  const relatedSlugs = relatedMap[currentSlug] ?? [];
  const related = relatedSlugs
    .map((s) => allExercises.find((e) => e.slug === s))
    .filter((e): e is Exercise => Boolean(e))
    .slice(0, 3);

  if (related.length === 0) return null;

  return (
    <section className="py-20 px-6 bg-cream-50 border-t border-charcoal-100">
      <div className="max-w-5xl mx-auto">
        {/* Header */}
        <div className="flex items-center gap-4 mb-10">
          <div className="flex-1 h-px bg-gold-200/60"></div>
          <div className="text-center">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-gold-50 border border-gold-200 rounded-full text-gold-700 text-xs font-semibold tracking-widest uppercase mb-3">
              <i className="ri-route-line"></i>
              Próximo passo na sua jornada
            </div>
            <h2 className="font-display text-3xl font-bold text-charcoal-900 leading-tight">
              Exercícios Relacionados
            </h2>
            <p className="text-charcoal-500 text-sm mt-2 font-light">
              Cada técnica potencializa a anterior. Continue evoluindo.
            </p>
          </div>
          <div className="flex-1 h-px bg-gold-200/60"></div>
        </div>

        {/* Cards */}
        <div className="grid md:grid-cols-3 gap-6">
          {related.map((ex, i) => (
            <Link
              key={ex.slug}
              to={`/exercicio-gratis/${ex.slug}`}
              className="group bg-white rounded-2xl border border-charcoal-100 hover:border-gold-300 transition-all duration-300 overflow-hidden flex flex-col cursor-pointer"
            >
              <div className="h-0.5 w-full bg-gradient-to-r from-gold-500 to-gold-700 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              <div className="p-6 flex flex-col flex-1">
                {/* Número de ordem */}
                <div className="flex items-start justify-between mb-4">
                  <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-charcoal-50 group-hover:bg-gold-50 border border-charcoal-100 group-hover:border-gold-200 transition-all duration-300">
                    <i className={`${ex.icon} text-2xl text-charcoal-400 group-hover:text-gold-600 transition-colors duration-300`}></i>
                  </div>
                  <span className="text-xs font-bold text-charcoal-300 font-mono">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                </div>

                <div className="flex items-center gap-2 mb-3 flex-wrap">
                  <span className={`text-xs font-semibold border px-2.5 py-1 rounded-full ${levelColors[ex.level]}`}>
                    {ex.level}
                  </span>
                  <span className="text-xs text-charcoal-400 flex items-center gap-1">
                    <i className="ri-time-line text-gold-400 text-xs"></i>
                    {ex.time}
                  </span>
                </div>

                <h3 className="font-display text-lg font-bold text-charcoal-800 mb-1 leading-snug group-hover:text-charcoal-900 transition-colors">
                  {ex.title}
                </h3>
                <p className="text-xs text-gold-500 font-semibold tracking-wide mb-3">{ex.subtitle}</p>
                <p className="text-sm text-charcoal-500 font-light leading-relaxed flex-1 mb-4">
                  {ex.description}
                </p>

                {/* Dica de conexão */}
                <div className="bg-gold-50 border border-gold-100 rounded-xl px-3 py-2.5 mb-4">
                  <p className="text-xs text-gold-700 leading-relaxed">
                    <i className="ri-lightbulb-line mr-1.5 text-gold-500"></i>
                    {ex.dica}
                  </p>
                </div>

                <div className="flex items-center justify-between mt-auto">
                  <span className="text-xs text-charcoal-400 flex items-center gap-1">
                    <i className="ri-group-line text-gold-400"></i>
                    {ex.praticantes} praticantes
                  </span>
                  <span className="text-xs font-semibold text-gold-600 group-hover:text-gold-700 flex items-center gap-1 transition-colors">
                    Praticar agora
                    <i className="ri-arrow-right-line group-hover:translate-x-0.5 transition-transform"></i>
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>

        {/* Link para todos */}
        <div className="text-center mt-10">
          <Link
            to="/exercicios-gratis"
            className="inline-flex items-center gap-2 text-sm text-charcoal-500 hover:text-gold-600 transition-colors font-medium"
          >
            <i className="ri-apps-2-line"></i>
            Ver todos os 12 exercícios gratuitos
            <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
